import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'DICT_ALL',
        delete: 'DICT_DELETE'
      },
      permission: {
        query: 'system:dict:query',
        add: 'system:dict:add',
        edit: 'system:dict:edit',
        detail: 'system:dict:detail',
        remove: 'system:dict:remove'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var _this2 = this;

      var h = this.$createElement;
      return [{
        prop: 'dict_name',
        label: '名称',
        minWidth: '100px',
        fixed: 'left',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-button", {
            "attrs": {
              "type": "text",
              "label": row.dict_name
            },
            "on": {
              "click": function click() {
                if (_this2.p('detail')) {
                  _this2.goDictData(row.id);
                }
              }
            }
          });
        }
      }, {
        prop: 'dict_type',
        label: '标识',
        minWidth: '100px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("d2-button", {
            "attrs": {
              "type": "text",
              "label": row.dict_type
            },
            "on": {
              "click": function click() {
                if (_this2.p('detail')) {
                  _this2.goDictData(row.id);
                }
              }
            }
          });
        }
      }, {
        prop: 'dict_value_type',
        label: '标识',
        minWidth: '100px',
        render: function render(_ref3) {
          var row = _ref3.row;
          return h("d2-dict", {
            "attrs": {
              "name": "dict_value_type",
              "value": row.dict_value_type
            }
          });
        }
      }, {
        prop: 'status',
        label: '状态',
        width: '100px',
        render: function render(_ref4) {
          var row = _ref4.row;
          return h("d2-dict", {
            "attrs": {
              "name": "status",
              "value": row.status
            }
          });
        },
        show: false
      }, {
        prop: 'remark',
        label: '备注',
        width: '100px',
        show: false
      }, {
        prop: 'create_by',
        label: '创建人员',
        width: '100px',
        show: false
      }, {
        prop: 'created_at',
        label: '创建时间',
        width: '200px',
        formatter: function formatter(row) {
          return utils.time.format1(row.created_at, 'YYYY/M/D HH:mm:ss');
        },
        show: false
      }, {
        prop: 'update_by',
        label: '更新人员',
        width: '100px',
        show: false
      }, {
        prop: 'updated_at',
        label: '更新时间',
        width: '200px',
        formatter: function formatter(row) {
          return utils.time.format1(row.updated_at, 'YYYY/M/D HH:mm:ss');
        },
        show: false
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this3 = this;

      return function (_ref5) {
        var row = _ref5.row;
        return [].concat(_toConsumableArray(_this3.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this3.edit(row.id);
          }
        }], [])), _toConsumableArray(_this3.p('detail', [{
          icon: 'el-icon-collection',
          action: function action() {
            return _this3.goDictData(row.id);
          }
        }], [])), _toConsumableArray(_this3.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: "\u786E\u5B9A\u5220\u9664 [ ".concat(row.dict_name, " ] \u5417"),
          action: function action() {
            return _this3.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this4 = this;

      var h = this.$createElement;
      return [{
        prop: 'dict_name',
        label: '名称',
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this4.search.form.model.dict_name,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "dict_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'dict_type',
        label: '标识',
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this4.search.form.model.dict_type,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "dict_type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: '开始时间',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "开始时间"
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.start_time,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: '结束时间',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "结束时间"
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.end_time,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        label: '状态',
        default: this.$env.VUE_APP_DICT_EMPTY_NUMBER,
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "status",
              "button": true,
              "all": true
            },
            "model": {
              value: _this4.search.form.model.status,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "status", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    goDictData: function goDictData(id) {
      this.closeBy(function (page) {
        return page.name === 'management-dict-data';
      });
      this.$router.push({
        name: 'management-dict-data',
        query: {
          dict_id: id
        }
      });
    }
  })
};